import type { FaqItem } from '../types/content'
import { siteConfig } from './siteConfig'

// Vragen met een leeg antwoord worden niet getoond.
export const faqs: FaqItem[] = [
  {
    question: 'Is dit ook geschikt als je nog nooit hebt gepunnikt?',
    answer:
      'Ja. De handleiding legt de materialen, het gereedschap en de basisstappen uit. Je kunt beginnen met eenvoudige vormen en in je eigen tempo verder oefenen.',
  },
  {
    question: 'Krijg ik boeken of materialen thuisgestuurd?',
    answer:
      'Nee. Dit is een digitaal product. Je ontvangt geen fysieke materialen. Garen, een punnikklosje of punnikmolen, metaaldraad en ander gereedschap zitten er niet bij.',
  },
  {
    // Taal van de handleidingen nog niet bevestigd: vraag verborgen tot er een bevestigd antwoord is.
    question: 'In welke taal zijn de handleidingen?',
    answer: '',
  },
  {
    question: 'Wat zit er in het pakket?',
    answer:
      'De handleiding Punniken met Liefde, De Creatieve Collectie en vier bonussen over decoraties, sleutelhangers, pennen en bedankjes.',
  },
  {
    question:
      'Zijn de collecties Kerst, Decoratieve ringen en Geboorte, doop en communie inbegrepen?',
    answer: 'Nee. Dit zijn aparte collecties en ze zitten niet in dit pakket.',
  },
  {
    question: 'Is het een abonnement?',
    answer: 'Nee. Je betaalt één keer voor het pakket.',
  },
  {
    question: 'Moet ik alles printen?',
    answer:
      'Je kunt de handleidingen digitaal bekijken en alleen de sjablonen printen die je wilt gebruiken.',
  },
  {
    question: 'Hoe ontvang ik de bestanden?',
    answer: siteConfig.deliveryAnswer,
  },
  {
    question: 'Mag ik mijn creaties verkopen?',
    answer: siteConfig.commercialUseAnswer,
  },
  {
    question: 'Is er een garantie of kan ik mijn geld terugkrijgen?',
    answer: siteConfig.refundAnswer,
  },
]
